import React from 'react';
import useFeatureIntroDrawer from 'src/components/10-atoms/feature-intro/useFeatureIntroDrawer';
import { overlayHelperViewActions } from 'src/components/20-helper-views/overlay/useOverlay';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import FTUEKeys from 'src/lib/ftue/keys';
import QPUploadIntroDrawer from '../../components/QPUploadIntroDrawer';
import QPFormOverlay from './QPForm';
export default function useAddQuestionPaper(subjectID) {
    const [qpUploadIntroFTUEState, qpUploadIntroFTUEActions] = useFeatureIntroDrawer(FTUEKeys.EP_QP_UPLOAD_INTRO);
    const addQuestionPaper = useStableCallback(async () => {
        if (qpUploadIntroFTUEState.ftue) {
            await qpUploadIntroFTUEActions.show(React.createElement(QPUploadIntroDrawer, { onDismiss: qpUploadIntroFTUEActions.hide }));
        }
        overlayHelperViewActions.show({
            component: (React.createElement(QPFormOverlay, { subjectID: subjectID, onClose: overlayHelperViewActions.hide, onComplete: overlayHelperViewActions.hide })),
        });
    });
    return addQuestionPaper;
}
